__turbopack_context__.v({
  "bodyCopy": "HeroBanner-module-scss-module__bRV6Na__bodyCopy",
  "bodyCopyContainer": "HeroBanner-module-scss-module__bRV6Na__bodyCopyContainer",
  "contentContainer": "HeroBanner-module-scss-module__bRV6Na__contentContainer",
  "desktopCta": "HeroBanner-module-scss-module__bRV6Na__desktopCta",
  "desktopImage": "HeroBanner-module-scss-module__bRV6Na__desktopImage",
  "heading": "HeroBanner-module-scss-module__bRV6Na__heading",
  "imageContainer": "HeroBanner-module-scss-module__bRV6Na__imageContainer",
  "mobileCta": "HeroBanner-module-scss-module__bRV6Na__mobileCta",
  "mobileImage": "HeroBanner-module-scss-module__bRV6Na__mobileImage",
});
